import { useState } from "react";
import "../styles/AniPage.css"

import cat_1 from "../assets/images/ani/cat_1.jpg";
import cat_2 from "../assets/images/ani/cat_2.jpg";
import cat_3 from "../assets/images/ani/cat_3.jpg";
import cat_4 from "../assets/images/ani/cat_4.jpg";
import cat_5 from "../assets/images/ani/cat_5.jpg";

export default function AniPage() {
  const [bg, setBg] = useState("bg1");

  const backgrounds = {
    bg1: { image: cat_1, text: "Обичаш ли ме?" },
    bg2: { image: cat_2, text: "Сигурна ли си?" },
    bg3: { image: cat_3, text: "Сигурна ли си, че си сигурна?" },
    bg4: { image: cat_4, text: "Ако ти купя сладолед, Kinder, бонбони, локум, халва, бургер, пица и ПЛЮШЕНА КОТКА?" },
    bg5: { image: cat_5, text: "Ураааааа!" },
  };

  const transitions = {
    bg1: { yes: "bg5", no: "bg2" },
    bg2: { yes: "bg3", no: "bg5" },
    bg3: { yes: "bg4", no: "bg5" },
    bg4: { yes: "bg5", no: "bg2" },
    //bg5: { yes: "bg5", no: "bg5" },
  };

  const handleChoice = (choice) => {
    setBg(transitions[bg][choice]);
  };

  return (
    <div
      className="ani-page"
      style={{ backgroundImage: `url(${backgrounds[bg].image})` }}
    >
      <div className="ani-overlay" />

      <div className="ani-content">
        <h1 className="ani-title">{backgrounds[bg].text}</h1>

        { bg !== "bg5" && (
          <div className="ani-buttons">
            <button className="btn btn-yes" onClick={() => handleChoice("yes")}>Да</button>
            <button className="btn btn-no" onClick={() => handleChoice("no")}>Не</button>
          </div>
        )}
      </div>
    </div>
  );
}
